import React from "react";
import { SlBadge } from "react-icons/sl";
import { FaChalkboardTeacher } from "react-icons/fa";
import { FaRankingStar, FaHeartPulse } from "react-icons/fa6";
import { motion } from "framer-motion";

const stats = [
  {
    icon: <SlBadge size={26} />,
    number: "ICSE & ISC",
    label: "Affiliation No. PU-158",
    accent: "rgba(244,200,66,0.8)",
    glow: "rgba(244,200,66,0.2)",
    borderColor: "rgba(244,200,66,0.2)",
  },
  {
    icon: <FaChalkboardTeacher size={26} />,
    number: "50+",
    label: "Experienced Teachers",
    accent: "rgba(99,102,241,0.9)",
    glow: "rgba(99,102,241,0.2)",
    borderColor: "rgba(99,102,241,0.2)",
  },
  {
    icon: <FaRankingStar size={26} />,
    number: "100%",
    label: "Result",
    accent: "rgba(34,197,94,0.9)",
    glow: "rgba(34,197,94,0.2)",
    borderColor: "rgba(34,197,94,0.2)",
  },
  {
    icon: <FaHeartPulse size={26} />,
    number: "100%",
    label: "Satisfied Parents",
    accent: "rgba(6,182,212,0.9)",
    glow: "rgba(6,182,212,0.2)",
    borderColor: "rgba(6,182,212,0.2)",
  },
];

const Certification = () => {
  return (
    <section className="relative py-24 px-6 overflow-hidden bg-[#020810]">
      {/* Background Decor */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-900/20 blur-[120px] rounded-full" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-purple-900/10 blur-[120px] rounded-full" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="section-badge mb-6">Affiliation & Standards</span>
          <h2
            className="font-black uppercase tracking-tight mb-6"
            style={{
              fontFamily: "Orbitron, sans-serif",
              fontSize: "clamp(2rem, 4vw, 3.5rem)",
              color: "#ffffff",
            }}
          >
            School <span className="text-gold">Milestones</span> & Standards
          </h2>
          <div className="w-24 h-1.5 bg-gold mx-auto rounded-full mb-8" />
          <p
            className="max-w-2xl mx-auto text-gray-400 font-medium leading-relaxed"
            style={{ fontSize: "clamp(1rem, 1.2vw, 1.15rem)" }}
          >
            Galaxy Star Public School, Sekhwan is affiliated with the Council for the Indian School Certificate Examinations (CISCE), New Delhi under Affiliation No. PU-158.
          </p>
        </motion.div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gold/5 blur-xl rounded-2xl group-hover:bg-gold/10 transition-colors" />
              <div className="relative glass-card-gold p-8 md:p-10 text-center border border-white/5 group-hover:border-gold/30 transition-all duration-500 h-full flex flex-col justify-between">
                <div>
                  <div
                    className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6 transition-transform duration-500 group-hover:scale-105"
                    style={{
                      background: "rgba(244,200,66,0.1)",
                      border: "1px solid rgba(244,200,66,0.2)",
                    }}
                  >
                    <div className="text-gold">{item.icon}</div>
                  </div>
                  <h3
                    className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl font-black text-white mb-2 tracking-tight"
                    style={{ fontFamily: "Orbitron, sans-serif" }}
                  >
                    {item.number}
                  </h3>
                </div>
                <p className="text-gold/90 font-bold uppercase tracking-widest text-xs mt-2">
                  {item.label}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certification;
